<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="$l('drawer_title_batchImport') || '系统用户批量导入'"
      visible
      direction="rtl"
      size="80%"
      :before-close="() => $refs.main.cancel()"
      @close="close()"
    >
      <div class="drawer-main">
        <Main ref="main" @close="close()" @reload="$emit('reload')" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  data() {
    return { visible: false }
  },
  methods: {
    close() {
      this.visible = false
    },
    open() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.main.init()
      })
    },
  },
}
</script>

<style scoped>
.drawer-main {
  padding: 0 20px 10px;
}
</style>
